import _drop from "lodash/drop";
import _isEmpty from "lodash/isEmpty";
import _join from "lodash/join";
import _size from "lodash/size";
import _take from "lodash/take";
import { TFunction } from "i18n";

const PREVIEW_ITEMS_LIMIT = 3;

export function formatListWithMore(values: string[], t: TFunction): string {
  if (_isEmpty(values)) {
    return "";
  }

  const visibleValues = _take(values, PREVIEW_ITEMS_LIMIT);
  const visibleValuesLabel = _join(visibleValues, ", ");
  const hiddenValuesCount = _size(_drop(values, PREVIEW_ITEMS_LIMIT));

  if (!hiddenValuesCount) {
    return visibleValuesLabel;
  }

  return t("common:jobs.page.rolePreferences.list.more", {
    visibleValuesLabel,
    hiddenValuesCount,
    moreLabel: t("common:button.label.more.lower"),
  });
}
